import { Component, OnInit } from '@angular/core';
import { BusinessProcessService } from '../../../../services/business-process.service';
import { Observable } from 'rxjs';
import { ActivatedRoute } from '@angular/router';
import { Utils } from '../../../../services/utils';
import { BusinessProcessVersionFilter } from '../../../../Models/businessProcessVersionFilter';
import { WebClientConfigurationService } from '../../../../services/configuration/web-client-configuration.service';
import { PaginationInstance } from 'ngx-pagination';
import {map, take, tap} from 'rxjs/operators';
import { GenericModalService } from '../../../../services/generic-modal.service';
import { RecoverVersionChangeLogComponent } from './recover-version-change-log.component';
import Swal from "sweetalert2";

@Component({
  selector: 'app-recover-version',
  templateUrl: './recover-version.component.html',
  styleUrls: ['./recover-version.component.css', '../../../../styles/business-process-configuration.css']
})
export class RecoverVersionComponent implements OnInit {

  constructor(
    private bpService: BusinessProcessService,
    private route: ActivatedRoute,
    private webClientConfig: WebClientConfigurationService,
    private modalService: GenericModalService
  ) { }

  utilsFunctions = Utils;

  bpId: number;
  bpVersion: number;
  bpName: string;
  bpDescription: string;
  bpOriginVersion: string;
  bpPublicationDate: Date;
  bpModifiedBy: string;
  bpNewVersion: number;
  onlyPublished: boolean = null;
  data: Observable<any[]>;
  hasData: boolean;
  isRecoveryRight = false;

  destComponent: any = RecoverVersionChangeLogComponent;
  filterParam: BusinessProcessVersionFilter;
  config: PaginationInstance;
  localTimeZone: string;

  errorMessage = '';
  successMessage = '';

  p = 1;
  total: number;

  ngOnInit() {
    this.localTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    this.bpId = Number(this.route.snapshot.paramMap.get('id'));
    this.getPage(1);
    this.checkRecoverRight();

    this.bpService.getBusinessProcessById(this.bpId)
      .subscribe( businessProcess => {
        this.bpName = businessProcess.name;
        this.bpVersion = businessProcess.version;
        this.bpDescription = businessProcess.description;
        this.bpOriginVersion = businessProcess.originalVersion > 0 ? businessProcess.originalVersion.toString() : '';

        this.bpService.getBusinessProcessPublicationInfo(this.bpId)
          .subscribe( publicationInfo => {
            console.log(publicationInfo);
            if (publicationInfo !== null) {
              this.bpNewVersion = publicationInfo.businessProcessVersion;
              this.bpPublicationDate = publicationInfo.publicationDate;
              this.bpModifiedBy = publicationInfo.publishedBy;
            }
          });
      }, error1 => {
        this.errorMessage = error1;
        console.error(error1);
      });
  }

  getPage(page: number) {
    this.filterParam = {
      businessProcessId: this.bpId,
      pageIndex: page,
      publishedVersions: this.onlyPublished ? true : null
    };

    this.data = this.bpService.getBusinessProcessOldVersions(this.filterParam)
      .pipe(
        tap( res => {
          this.total = res.total;
          this.p = page;
          this.getPaginationConfig(page, res.total);
        }, error1 => {
          this.errorMessage = error1;
        }),
        map( res => res.businessProcessVersions)
      );

    this.data.subscribe( value => this.hasData = value.length > 0 );
  }

  getPaginationConfig(_currentPage: number, _totalItems: number) {
    this.webClientConfig.getPageSizeConfig().subscribe(item => {
      this.config  = {
        id: 'server',
        itemsPerPage: item,
        currentPage: _currentPage,
        totalItems: _totalItems
      };
    });
  }

  viewChangeLog(version: string) {
    this.modalService.showModal(this.destComponent, 'Detalhes do Changelog', this.bpId, version, 'modal-xl');
  }

  recoverBusinessProcessVersion(bpVersion: number) {
    this.errorMessage = '';
    this.successMessage = '';
    let alert: any;
    alert = this.modalService
      .showConfirmModal('Confirmação de Recuperação de Versão', 'Confirma a recuperação de dados?');

    alert.then((result) => {
      if (result.value) {
        this.bpService.recoverBusinessProcessVersion(this.bpId, bpVersion).subscribe(s => {
          this.successMessage = `A <i>versão ${bpVersion}</i>  do processo de negócio foi recuperada com sucesso.`;
          setTimeout(() => {
            this.successMessage = '';
            this.ngOnInit();
          }, 2000);
        }, error1 => {
          this.errorMessage = error1;
          if (error1 === 'Erro: Usuário não tem direito de efetuar esta ação.') {
            this.ngOnInit();
          }
        });
      }
    });
  }

  checkRecoverRight() {
    this.bpService.checkRights(128).subscribe(s => {
      this.isRecoveryRight = s.length > 0;
    }, error1 => {
      this.errorMessage = error1;
      console.error(error1);
    });
  }
}
